import React from 'react';
import { useTranslation } from 'react-i18next';
import UpgradeCta from './UpgradeCta';

export function checkInHasPhotos(checkIn) {
  return Boolean(
    checkIn?.photos?.before?.length > 0 || checkIn?.photos?.after?.length > 0
  );
}

function TaskPhotos({
  canCheckOut = false,
  canUploadTaskImages,
  checkOutData,
  onFileChange,
  checkIns,
  onSelectPhoto,
  showUpload = true
}) {
  const { t } = useTranslation(['tasks']);

  const showUploadSection = showUpload && canCheckOut;
  const photoCheckIns = Array.isArray(checkIns)
    ? checkIns.filter(checkInHasPhotos)
    : [];
  const showPhotoHistory = photoCheckIns.length > 0;

  if (!showUploadSection && !showPhotoHistory) {
    return null;
  }

  const beforeSelected = checkOutData?.beforePhotos?.length || 0;
  const afterSelected = checkOutData?.afterPhotos?.length || 0;

  return (
    <div className="task-detail-section card">
      <h3 className="task-section-label">{t('tasks:photosSection')}</h3>

      {showUploadSection && (
        <div className="task-photos-container">
          {canUploadTaskImages ? (
            <>
              <div className="task-photo-group">
                <h4 className="task-photo-group-label">{t('tasks:beforePhotos')}</h4>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => onFileChange(e, 'beforePhotos')}
                  className="task-photo-input"
                />
                {beforeSelected > 0 && (
                  <p className="task-photo-count">
                    {t('tasks:filesSelected', { count: beforeSelected })}
                  </p>
                )}
              </div>
              <div className="task-photo-group">
                <h4 className="task-photo-group-label">{t('tasks:afterPhotos')}</h4>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => onFileChange(e, 'afterPhotos')}
                  className="task-photo-input"
                />
                {afterSelected > 0 && (
                  <p className="task-photo-count">
                    {t('tasks:filesSelected', { count: afterSelected })}
                  </p>
                )}
              </div>
            </>
          ) : (
            <UpgradeCta className="task-photos-note" />
          )}
          {showPhotoHistory && (
            <p className="task-photos-note">{t('tasks:uploadedPhotosNote')}</p>
          )}
        </div>
      )}

      {showPhotoHistory && photoCheckIns.map((checkIn) => (
        <div key={checkIn.id} className="check-in-item">
          <p><strong>{checkIn.user_name}</strong></p>
          <div className="check-in-photos">
            {checkIn.photos?.before?.length > 0 && (
              <div className="photo-group">
                <h4>{t('tasks:beforePhotoAlt')}</h4>
                <div className="photo-grid">
                  {checkIn.photos.before.map((photo) => (
                    <button
                      type="button"
                      key={`before-${photo.id}`}
                      className="photo-item"
                      onClick={() =>
                        onSelectPhoto({
                          ...photo,
                          photo_type: 'before',
                          user_name: checkIn.user_name,
                          check_in_time: checkIn.check_in_time
                        })
                      }
                    >
                      <img src={photo.file_url} alt={t('tasks:beforePhotoAlt')} />
                    </button>
                  ))}
                </div>
              </div>
            )}
            {checkIn.photos?.after?.length > 0 && (
              <div className="photo-group">
                <h4>{t('tasks:afterPhotoAlt')}</h4>
                <div className="photo-grid">
                  {checkIn.photos.after.map((photo) => (
                    <button
                      type="button"
                      key={`after-${photo.id}`}
                      className="photo-item"
                      onClick={() =>
                        onSelectPhoto({
                          ...photo,
                          photo_type: 'after',
                          user_name: checkIn.user_name,
                          check_in_time: checkIn.check_in_time
                        })
                      }
                    >
                      <img src={photo.file_url} alt={t('tasks:afterPhotoAlt')} />
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TaskPhotos;
